import Component from '../colorz/Component';
import device   from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

/*
 * Slider photos de la page single Expertise
 * voir template strate-expertise-slider-photos.php
 * @type {Slider}
 */

module.exports = class ExpertiseSliderPhotos extends Component{
    onInit( el, args ) {
        this.onNext     = this.onNext.bind(this);
        this.onPrev     = this.onPrev.bind(this);

        this.el = el;

        if (window.matchMedia("(min-width:1080px)").matches) {
            this.nextBtn = this.el.querySelector('.sliderBtns__button--next');
            this.prevBtn = this.el.querySelector('.sliderBtns__button--prev');
            this.enablePrev = false;
            this.enableNext = true;
        }
    }

    onReady() {

        // init slider
        this.initSlider();

        if (window.matchMedia("(min-width:1080px)").matches) {
            // events on nav buttons
            this.nextBtn.addEventListener(device.pointerdown, this.onNext);
            this.prevBtn.addEventListener(device.pointerdown, this.onPrev);

            // disable prev button on load
            this.disableButtons();
        }

        // disable horizontal scroll
        document.body.classList.add('js-has-flickity');


    }

    onNext() {
        this.slider.next();
        this.switchBtnsState();
    }

    onPrev() {
        this.slider.previous();
        this.switchBtnsState();
    }

    switchBtnsState(){
        (this.slider.selectedIndex == 0) ? this.enablePrev = false : this.enablePrev = true;
        (this.slider.selectedIndex == (this.slider.cells.length - 3)) ? this.enableNext = false : this.enableNext = true;

        this.disableButtons();
    }

    disableButtons(){
        if(!this.enablePrev){
            this.prevBtn.classList.add('disabled');
        } else {
            this.prevBtn.classList.remove('disabled');
        }

        if(!this.enableNext){
            this.nextBtn.classList.add('disabled');
        } else {
            this.nextBtn.classList.remove('disabled');
        }
    }

    initSlider(){
        var options = {
            cellSelector: '.js-slide',
            imagesLoaded: true,
            pageDots: false,
            cellAlign : 'left',
            prevNextButtons: false,
            draggable: true,
        };

        // init slider
        this.slider = new Flickity(this.el, options);
    }

};
